import BootstrapInput from '@components/common/basic-input/bootstrap-input';
import useStationSelector from '@components/common/station-selector/use-station-selector';
import { IStationSelector } from '@helpers/types';
import {
  Autocomplete,
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from '@mui/material';

const StationSelector = (props: IStationSelector) => {
  const { stations, onChangeStation, isLoading } = useStationSelector(
    props.onChange,
    props.currenCountry,
  );
  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return (
    <Autocomplete
      size={props.size || 'medium'}
      fullWidth
      id="autocomplete"
      options={stations}
      disabled={props.disabled}
      //@ts-ignore
      value={props.station}
      disableClearable={props.disableClearable ?? true}
      onChange={onChangeStation}
      getOptionLabel={(option) => option.station}
      isOptionEqualToValue={(option, value) =>
        option?.station === value?.station
      }
      renderInput={(params) => {
        const { InputLabelProps: _InputLabelProps, InputProps, ...rest } = params;
        return (
          <FormControl fullWidth>
            {!props.placeholder && (
              <InputLabel htmlFor="autocomplete">
                {props.label ?? 'Estación'}
              </InputLabel>
            )}
            {!props.isOutlined ? (
              <BootstrapInput {...InputProps} {...rest} />
            ) : (
              <OutlinedInput
                label={props.placeholder ? undefined : props.label}
                {...InputProps}
                {...rest}
                placeholder={props.placeholder}
              />
            )}
            <FormHelperText>
              <strong>{props.hint ?? ''}</strong>
            </FormHelperText>
          </FormControl>
        );
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <span>
            {option.station.toUpperCase()}
            <sup>{option.country}</sup>
          </span>
        </Box>
      )}
    />
  );
};
export default StationSelector;
